import { Injectable } from '@angular/core';
import { RegPatService } from '../../pricing/reg-pat-service/reg-pat-service';
import { HttpGeneralService } from '../../shared';
import { CONFIG } from '../../shared/config';
let serviceDetailUrl = CONFIG.baseUrls.RegPatServiceWorkFlow;
@Injectable({
  providedIn: 'root'
})
export class GenPatientServiceDetailService {
  constructor(private _httpGeneralService: HttpGeneralService) {
  }
  genPatientServiceDetailLoad(_parms: any) {
    let obj: RegPatService = {};
    obj.serial = _parms.regPatServiceSerial;
    obj.ccCallSerial = _parms.ccCallSerial;
    
    return this._httpGeneralService.add(obj, `${serviceDetailUrl}/GenPatientServiceDetail`)
  }
}
